<template>
	<footer class="page-footer">
		<div class="footer-left">
			<span
				class="copyright trait-gauche"
			>© Copyright {{ yearDate }} - Tous droits réservés GRETA-CFA Pays de La Loire - <a href="https://www.greta-cfa-paysdelaloire.fr/conditions-generales-de-vente/">CGV</a></span>

			<div class="footer-logo">
					<a href="https://www.greta-cfa-paysdelaloire.fr/">
						<img class="classic" src="@img/logo-gretapdl.png" alt="Logo Greta PDL">
					</a>
			</div>

			<div class="to-top">
				<a class="js-smooth-scroll" href="#header">
					<i class="fa fa-chevron-up" aria-hidden="true"></i>
				</a>
			</div>
		</div>

		<div class="footer-right">
			<div class="logos-sociaux">
				<a href="https://twitter.com/gretacfapdl" target="_blank">
					<i class="fa fa-twitter" aria-hidden="true"></i>
				</a>
				<a href="https://www.facebook.com/greta.cfa.paysdelaloire" target="_blank">
					<i class="fa fa-facebook" aria-hidden="true"></i>
				</a>
				<a href="https://www.linkedin.com/company/greta-cfapaysdelaloire/" target="_blank">
					<i class="fa fa-linkedin" aria-hidden="true"></i>
				</a>
				<a href="https://www.youtube.com/channel/UCIkOjqNK5sZTzPsM9ceYDRQ" target="_blank">
					<i class="fa fa-youtube" aria-hidden="true"></i>
				</a>
			</div>
			<span class="trait-gauche">
				<a href="https://www.greta-cfa-paysdelaloire.fr/mentions-legales/">Mentions légales</a>
			</span>
			<span class="trait-gauche">
				<span>Création et développment</span>
				<span>Kookline</span>
			</span>
			<!-- <a class="logo-academie" href="/">
				<img src="@img/logo-academie.png" alt="Logo Académie de Nantes" />
			</a> -->
			<a class="logo-eduform" href="/">
				<img src="@img/logo-eduform.jpg" alt="Logo Eduform" />
			</a>
			<a class="logo-datadocke" href="/">
				<img src="@img/logo-datadocke.jpg" alt="Logo Datadocké" />
			</a>
		</div>
	</footer>
</template>

<script>
/**
 * Template de posts permettant d'afficher tous les articles du blog
 */
export default {
	computed: {
		yearDate() {
			return new Date().getFullYear();
		},
	},
};
</script>

<style lang="scss" scoped>
@import '~@scss/_vars.scss';

.page-footer {
	display: flex;
	align-items: center;
	position: relative;
	width: 100%;
	height: 170px;
	z-index: 1;

	@media screen and (max-width: $break-large) {
		height: auto;
	}

	@media screen and (max-width: $break-medium) {
		flex-direction: column;
	}

	.footer-left {
		position: relative;
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 40%;
		height: 100%;
		padding-left: 40px;
		background-color: $mainColor;
		color: white;

		@media screen and (max-width: 1630px) {
			padding-left: 10px;
			justify-content: center;
		}

		@media screen and (max-width: $break-large) {
			flex-direction: column-reverse;
			text-align: center;
			padding: 0 0 60px 0;
		}

		@media screen and (max-width: $break-medium) {
			width: 100%;
		}

		.footer-logo{
			background-color: #fff;
			border-bottom-left-radius: 20px;
			border-bottom-right-radius: 20px;
			padding: 20px 30px;
			margin-right: 20px;
			align-self: start;

			@media screen and (max-width: $break-large) {
				align-self: center;
			}
		}

		img {
			@media screen and (max-width: 1800px) {
				width: 150px;
			}
		}

		.copyright {
			font-size: 12px;
			line-height: 17px;
			width: 270px;
			display: block;

			a{
				display: inline;
				color: white;
			}

			@media screen and (max-width: 1630px) {
				width: 250px;
				margin-left: 0;
				margin-top: 25px;
			}

			@media screen and (max-width: $break-large) {
				&::before {
					width: 30px;
					height: 2px;
					top: -10px;
					left: 50%;
					transform: translateX(-50%);
				}
			}
		}

		.to-top {
			position: absolute;
			top: 0;
			right: 0;
			transform: translate(50%, -50%);

			a {
				display: flex;
				justify-content: center;
				align-items: center;
				width: 65px;
				height: 65px;
				border-radius: 65px;
				background-color: $secondaryColor;
				text-decoration: none;
				color: white;
				margin: 0;
				font-size: 25px;
				font-weight: normal;
			}

			@media screen and (max-width: $break-medium) {
				top: auto;
				right: auto;
				bottom: -33px;
				left: 50%;
				transform: translateX(-50%);
			}
		}
	}

	.footer-right {
		width: 60%;
		height: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding-left: 90px;
		padding-right: 50px;
		background-color: #fff;

		@media screen and (max-width: 1340px) {
			padding-left: 20px;
			padding-right: 20px;
		}

		@media screen and (max-width: $break-medium) {
			flex-direction: column;
			width: 100%;
			padding-top: 90px;
		}

		span {
			color: $mainColor;
			font-size: 12px;
			line-height: 17px;
			font-weight: bold;
		}

		a {
			@media screen and (max-width: $break-medium) {
				margin-bottom: 20px;
			}
		}

		.logos-sociaux {
			display: flex;
			justify-content: space-between;
			align-items: center;

			> a {
				display: flex;
				justify-content: center;
				align-items: center;
				width: 45px;
				height: 45px;
				border: 2px solid $secondaryColor;
				border-radius: 45px;
				transition: all 0.3s ease-in-out;

				&:not(:first-child) {
					margin-left: 10px;
				}

				i {
					font-size: 23px;
				}
			}
		}

		.trait-gauche {
			@media screen and (max-width: $break-medium) {
				margin-bottom: 40px;
				margin-left: 0;
				align-items: center;

				span {
					font-size: 14px;
					line-height: 22px;
					font-weight: 500;
				}
			}
			&::before {
				@media screen and (max-width: $break-medium) {
					top: -27px;
					left: 50%;
					transform: translateX(-50%) rotate(90deg);
				}
			}
		}
	}

	.trait-gauche {
		position: relative;
		margin-left: 20px;
		display: flex;
		justify-content: flex-start;
		align-items: flex-start;
		flex-direction: column;

		&::before {
			content: '';
			position: absolute;
			left: -10px;
			top: 50%;
			transform: translateY(-50%);
			height: 30px;
			width: 2px;
			background-color: $secondaryColor;
		}
	}

	@media screen and (max-width: $break-medium) {
		padding-bottom: 65px;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/global/Footer.vue